import { type RouteObject } from "react-router-dom";
import {
  HomePage,
  DataPage,
  DataDetailsPage,
  ContactPage,
  VisualAnalysisPage,
} from "./pages";
import { AppLayout } from "./layouts";

export const routes: RouteObject[] = [
  {
    Component: AppLayout,
    children: [
      { index: true, Component: HomePage },
      { path: "/home", Component: HomePage },
      { path: "/data", Component: DataPage },
      { path: "/visual-analysis", Component: VisualAnalysisPage },
      { path: "/contact", Component: ContactPage },
    ],
  },
  // Opens in new tab — no shared header/layout
  { path: "/data/details/:bsadbId", Component: DataDetailsPage },
];
